export const invitationUrl = "invitation";
export const loanProductsUrl = "loan-products";
export const loanProductUrl = "loan-product";
export const investeeAllDataUrl = "investee-all-data";
export const smsBalanceUrl = "sms-balance";
export const fundingApplicationUrl = "funding-application";
export const cancelUrl = "cancel";
export const verifyUrl = "verify";
export const rejectUrl = "reject";
export const rejectToPendingUrl = "reject-to-pending";
export const processingToVerifyUrl = "processing-to-verify";
export const approveUrl = "approve";
export const disburseUrl = "disburse";
export const bringToSignedByInvesteeUrl = "admin-investee-agreement";
export const bankListUrl = "bank";
export const updateBankDetailsUrl = "bank-details";
export const approveBankDetailsUrl = "bank-details/approve";
export const userLoanHistory = "loan-history";
export const usersUrl = "users";
export const usersFilterOptionsUrl = "users/filter-options";
export const addUserUrl = "users/store";
export const uploadUsersExcelUrl = "import/users";
export const uploadChaldalUsersExcelUrl = "import/chaldal-users";
export const downloadUsersExcelUrl = "export/users";
export const uploadInvitationsExcelUrl = "import/invitations";
export const uploadLoanApplicationsExcelUrl = "import/loan-applications";
export const uploadPaymentsExcelUrl = "import/payment";
export const upfrontPaymentApiUrl = "import/upfront-payment";
export const validateNIDUrl = "nid-verify";
export const fundingEMIList = "emi-list";
